import request from "../http/request";
//获取用户的订单列表
export const getAppConfig = () => {
  return request({
    url: "/userapp/brand/info",
    method: "get",
  });
};
